//根据基础费率来控制指定机构的覆盖情况。
/****
会概率配置了该国家套餐，
但是没有配置该国家的费率状态，
即会出现查询不出该国家显示情况
****/


let QueryRateList = {
    appThat: null,
    setAppThat: function(appThat){
        this.appThat = appThat;
        return this;
    }
}

QueryRateList.search = async function( fn ){
	let val;
	await QueryRateList.appThat.$http.post({
		url: '/bss/app/noauth/QueryRateList',
        data: {                        
			"perPageCount":300,
			"currentPage": 1
        }
	}).then(res => {
		if(QueryRateList[fn]){
			val = QueryRateList[fn](res);
		}else{
			val = QueryRateList.filterValue(res);	
		}
	}).catch(err => {
	    //提示用户稍后查询
	})
	return val;
}

QueryRateList.filterNumber = function(res){
	return res.data.totalCount;
}

QueryRateList.ReturnCountryNumber = async function(){
	return await QueryRateList.search("filterNumber");
}

QueryRateList.filterValue = function(res){
	let filterValue = res.data.dataList,RateCountryList= [];
	filterValue.forEach(function(value){
		value.countryName = value.country
		if(value.iso2 != "ALL"){
			RateCountryList.push(value);
		}
	});
	
	return {data:RateCountryList};
}


export default QueryRateList;